export const SDK_VERSION = '7.11.1';
